<template>
  <div
    :class="$style.container"
    id="library"
    v-loading.fullscreen.lock.body="loading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
    style="flex-grow: 1"
  >
    <!--<ul id="remenu" :style="{left:left,top:top,}" v-if="isAmenu" @mouseover="myMouseover" @mouseout="myMouseout">-->
    <!--<li @click="fraternalClick" >添加同级文件夹</li>-->
    <!--&lt;!&ndash;:class="{selectMenuE:isAm1}"&ndash;&gt;-->
    <!--<li @click="childrenClick" >添加下级文件夹</li>-->
    <!--</ul>-->

    <el-container style="height: 100%;padding:0;">
      <div width="360px" style="padding-top:10px;">
        <div :class="$style.left" style="height: 100%;display:flex;flex-direction: column;">
          <el-row style="margin-bottom: 10px;height: 32px">
            <el-col :span="12">
              <div style="padding-top: 8px;font-size: 20px">资料库</div>
            </el-col>
            <el-col :span="12">
              <div align="right">
                <el-button type="success" icon="el-icon-plus" size="small" @click="addFiles" v-if="mynewFles">
                  新文件夹
                </el-button>
              </div>
            </el-col>
          </el-row>

          <div ref="scrollbar" id="myregion" style="border: 1px solid #dedede; flex-grow:1;overflow: hidden">
            <div style="height: 100%">
              <el-autocomplete
                id="myInput"
                v-model="input"
                placeholder="请输入文件夹名称进行快速搜索"
                :fetch-suggestions="search"
                @select="handleSelect"
                :class="$style.search"
                style="display: flex;justify-content: center;margin: 0px 0"
              >
                <span slot-scope="{ item }">
                  <img :src="icon_forder" height="15px" style="vertical-align: middle;margin-left: 4px" />
                  <span style="margin-left: 21px;font-size: 14px;color: #555555">{{ item.title }}</span>
                </span>
              </el-autocomplete>
              <!-- @node-contextmenu="rightClick"-->
              <el-tree
                :class="{ mySelect: isActive }"
                ref="menusTree"
                :data="folderArry"
                :props="defaultProps"
                :expand-on-click-node="false"
                :auto-expand-parent="true"
                node-key="id"
                :current-node-key="currentNodeKey"
                :highlight-current="isActive2"
                @node-expand="isActive = false"
                :default-expanded-keys="defaultExpandedKeys"
                @node-click="handleNodeClick"
              >
                <span style="margin-top: 20px;margin-bottom: 20px" slot-scope="{ node, data }">
                  <img :src="icon_forder" height="15px" style="vertical-align: middle" />
                  <!--<span :class="['iconfont', $style.first]" v-if="node.level === 1"></span>-->
                  <span :class="$style.font">{{ node.label }}</span>
                </span>
              </el-tree>
            </div>
          </div>
        </div>
      </div>
      <el-main height="100%" style="padding-bottom: 0">
        <div :class="$style.right">
          <div :class="$style.header" style="height: 54px;padding-top: 10px;box-sizing: border-box;">
            <el-row type="flex" align="middle">
              <el-col :span="2">
                <div style="padding-top: 8px;font-size: 20px;color:rgb(74, 144, 226)">文件夹</div>
              </el-col>
              <el-col :span="10">
                <div align="left" style="padding-top: 8px; color: cornflowerblue">{{ myobj.name }}</div>
              </el-col>
              <el-col :span="12">
                <div align="right">
                  <el-button type="warning" size="small" @click="dianji" v-if="!isActive3">
                    编辑
                  </el-button>
                </div>
              </el-col>
            </el-row>
          </div>

          <!--<div :class="$style.header">-->
          <!--<span>文件夹</span>-->
          <!--<span>{{companyName}}</span>-->

          <!--</div>-->

          <!--<div align="right">-->
          <!--<el-button type="primary" icon="el-icon-edit">编辑</el-button>-->
          <!--</div>-->

          <div :class="$style.body">
            <!--<router-view></router-view>-->
            <!--<el-scrollbar :class="$style.scrollbar" >-->
            <router-view :key="key"></router-view>
            <!--</el-scrollbar>-->
          </div>
        </div>
      </el-main>
    </el-container>

    <div :class="$style.title"></div>
    <el-dialog
      :visible.sync="dialogVisible"
      width="35%"
      :show-close="false"
      :before-close="handleClose"
      style="vertical-align: center;: #FFF9F3"
    >
      <div style="margin-top: -40px">
        <el-row style="border-bottom: 2px dotted #e7eaec;padding-bottom: 10px;">
          <el-col :span="12">
            <div style="color: #3998F7;font-weight: bold;padding-top: 8px;font-size: 16px">{{ file_title }}</div>
          </el-col>

          <el-col :span="12">
            <div align="right">
              <el-button type="primary" size="small" @click="inputMyAppend(myobj)">
                保存
              </el-button>
              <el-button type="danger" size="small" @click="closeAppend">
                取消
              </el-button>
            </div>
          </el-col>
        </el-row>
        <div class="subjectList" style="margin-top: 20px;">
          <el-form
            ref="appendForm"
            label-width="100px"
            style="text-align: right"
            :model="appendForm"
            hide-required-asterisk
          >
            <el-form-item label="上级文件夹" style="font-weight:800">
              <div align="left" style="color: cornflowerblue">{{ myobj.name }}</div>
            </el-form-item>
            <el-form-item
              label="名称"
              class="library_star"
              prop="folderName"
              :rules="[{ required: true, message: '名称不能为空' }]"
            >
              <el-input v-model="appendForm.folderName" placeholder="请输入文件夹名称"></el-input>
            </el-form-item>
            <el-form-item label="简介">
              <el-input v-model="appendForm.account" placeholder="请输入简介" type="textarea"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="dialogVisible2"
      width="35%"
      :show-close="false"
      :before-close="handleClose"
      @close="reset"
      style="vertical-align: center;: #FFF9F3"
    >
      <div style="margin-top: -40px">
        <el-row style="border-bottom: 2px dotted #e7eaec;padding-bottom: 10px;">
          <el-col :span="12">
            <div style="color: #3998F7;font-weight: bold;padding-top: 8px;font-size: 16px">编辑文件夹</div>
          </el-col>

          <el-col :span="12">
            <div align="right">
              <el-button type="primary" size="small" @click="inputEdit">
                保存
              </el-button>
              <el-button type="danger" size="small" @click="closeEdit">
                取消
              </el-button>
            </div>
          </el-col>
        </el-row>
        <div class="subjectList" style="margin-top: 20px;">
          <el-form
            ref="editForm"
            label-width="100px"
            style="text-align: right"
            :model="editForm"
            hide-required-asterisk
          >
            <!--<el-form-item label="上级文件夹" style="font-weight:800">-->
            <!--<div align="left" style="color: cornflowerblue">{{companyName}}</div>-->
            <!--</el-form-item>-->

            <el-form-item
              label="名称"
              class="library_star"
              prop="folderName"
              :rules="[{ required: true, message: '名称不能为空' }]"
            >
              <el-input v-model="editForm.folderName" placeholder="请输入文件夹名称"></el-input>
            </el-form-item>
            <el-form-item label="简介">
              <el-input v-model="editForm.account" placeholder="请输入简介" type="textarea"></el-input>
            </el-form-item>
            <!--                        <el-form-item label="状态" style="font-weight:800">-->
            <!--                            <el-switch-->
            <!--                                    v-model="status"-->
            <!--                                    active-value="ACTIVE"-->
            <!--                                    inactive-value="INACTIVE"-->
            <!--                            >-->
            <!--                            </el-switch>-->
            <!--                        </el-form-item>-->
          </el-form>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import TreeNode from './components/treeNode'
import http from '../../APIService/http'
import http2 from '../../APIService/http2'
import { bus } from '../../router/index.js'
import ImgUrl_n_red from '../../assets/images/folder_icon.png'

export default {
  data() {
    return {
      mynewFles: false,
      setTim: null,
      isAm1: false,
      isAm2: false,
      isAmenu: false,
      top: '0px',
      left: '0px',
      isActive: false,
      isActive2: true,
      isActive3: true,
      library_id: '',
      status: 'ACTIVE',
      myIndex: '',
      myobj: {
        name: '',
        id: '',
      },
      dialogVisible: false,
      dialogVisible2: false,
      isFirst: true,
      loading: false,
      userId: '',
      input: '',
      queryString: '',
      oldtreeNodes: [
        { id: 'id01', value: '文件夹1' },
        { id: 'id02', value: '文件夹2' },
      ],
      folderArry: [],
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      timeout: null,
      options: [],
      distributorInfo: [],
      storeInfo: [],
      defaultExpandedKeys: [],
      total: 0,
      showDistributor: false,
      showStore: false,
      showCompany: true,
      companyName: '',
      branchId: '',
      id: '',
      file_title: '',
      folderName: '',
      account: '',
      icon_forder: ImgUrl_n_red,

      clientHeight: '',
      appendForm: {
        folderName: '',
        account: '',
      },
      editForm: {
        folderName: '',
        account: '',
      },
      currentNodeKey: '',

      //                defaultProps: {
      //                    label: 'title'
      //                },
    }
  },
  mounted() {
    this.$refs['menusTree'].setCurrentKey(this.folderArry[0].id)

    //            this.$router.go(-1)
  },
  async created() {
    this.arraylist()
    this.$router.push({ path: '/library/index?&index=1' })

    //            let obj = this.$store.getters.getUser || {}
    //
    //            this.userId = obj._id
    //
    //            this.getForderList()
  },
  computed: {
    distributorName() {
      let store = this.$store.getters.getStore || {}
      if (store.distributorName) {
        return store.distributorName
      } else {
        return ''
      }
    },
    key() {
      return this.$route.name !== undefined ? this.$route.name + +new Date() : this.$route + +new Date()
    },
  },
  methods: {
    dianji() {
      this.editForm.folderName = this.companyName
      this.editForm.account = this.sub_title
      this.dialogVisible2 = true
    },
    addFiles() {
      ;(this.appendForm = {
        folderName: '',
        account: '',
      }),
        (this.dialogVisible = true)
    },
    reset() {
      this.folderName = ''
      this.account = ''
    },
    inputEdit() {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          this.edit()
        } else {
          return false
        }
      })
    },
    closeEdit() {
      this.dialogVisible2 = false
      this.$refs['editForm'].resetFields()
    },
    async edit() {
      try {
        let data = {
          tenant_id: this.$store.getters.getUser.tenant_id,
          title: this.editForm.folderName,
          sub_title: this.editForm.account,
          status: this.status,
          user_id: this.$store.getters.getUser.user_id,
          id: this.id,
        }
        await http.post('/wapi/dataBank/edit', data).then((res) => {
          console.log(res)
        })
      } catch (err) {
        this.loading = false
      }
      this.arraylist()
      this.myobj.name = this.folderName
      this.folderName = ''
      this.account = ''

      //                this.status='ACTIVE'
      this.dialogVisible2 = false
    },

    async arraylist() {
      try {
        let data = {
          tenant_id: this.$store.getters.getUser.tenant_id,
          user_id: this.$store.getters.getUser.user_id,
        }

        await http.post('/wapi/dataBank/list', data).then((res) => {
          //                    console.log(res.data)
          this.library_id = res.data.library_id

          this.folderArry = res.data.list
          //                    if(this.folderArry.length>0){
          ////                        this.isActive=true
          ////                        this.myobj=res.data.list[0]
          //                    }
          this.loading = false
        })
      } catch (err) {
        this.loading = false
      }
    },

    async myfileList() {
      try {
        let data = {
          tenant_id: this.$store.getters.getUser.tenant_id,
          id: this.id,
        }
        await http.post('/wapi/dataBank/fileList', data).then((res) => {
          // console.log(res)
          this.tableData = res.data
        })
      } catch (err) {
        this.loading = false
      }
    },
    //            async getForderList() {
    //                this.loading = true
    //                try {
    //
    //                    let data = {
    //
    //                        tenant_id: this.$store.getters.getUser.tenant_id,
    //                        user_id: this.$store.getters.getUser.user_id,
    //
    //                    }
    //
    //                    await http.post('/wapi/v1/getForderList', data).then(res => {
    //
    //                        this.folderArry = res.data.folderArry
    //
    //
    //                        if (this.folderArry.length > 0) {
    //                            let folderObj = this.folderArry[0]
    //
    //                            this.companyName = folderObj.title
    //
    //                            this.$store.commit('setDatabase', {
    //                                tenant_id: folderObj.tenant_id,
    //                                library_id: folderObj.library_id,
    //                                catalog_id: folderObj.catalog_id,
    //                                title: folderObj.title
    //                            })
    //                        }
    //
    //                        this.$router.push({
    //                            path: '/database/index'
    //                        })
    //
    //
    //                        this.loading = false
    //
    //                    })
    //                    //
    //                } catch (err) {
    //                    this.loading = false
    //                    console.log(`error:${err}`)
    //                }
    //            },
    handleClose(done) {
      //                this.$confirm('确认关闭？')
      //                    .then(_ => {
      done()
      //                    })
      //                    .catch(_ => {});
    },
    //            addFolderClick(num) {
    //                this.dialogVisible = true
    //
    //                if (num === 0) {
    //
    //                    this.file_title = '新建文件夹'
    //                    this.folderName = ''
    //                    this.account=''
    //                } else {
    //                    let detabaseObj = this.$store.getters.getDatabase
    //                    this.file_title = '编辑文件夹'
    //                    this.folderName = detabaseObj.title
    //                }
    //            },
    //            async saveFolder() {
    //                if (this.file_title === '新建文件夹') {
    //                    this.addEditFolder(false)
    //                } else if (this.file_title === '编辑文件夹') {
    //                    this.addEditFolder(true)
    //                }
    //            },
    //            async addEditFolder(isEdit) {
    //                try {
    //                    this.loading = true
    //
    //                    let detabaseObj = this.$store.getters.getDatabase
    //
    //                    let data
    //                    if (!isEdit) {
    //                        data = {
    //                            tenant_id: this.$store.getters.getUser.tenant_id,
    //                            user_id: this.$store.getters.getUser.user_id,
    //                            title: this.folderName,
    //                            children:this.account,
    //                            isEdit: isEdit
    //                        }
    //                    } else {
    //                        data = {
    //                            tenant_id: this.$store.getters.getUser.tenant_id,
    //                            user_id: this.$store.getters.getUser.user_id,
    //                            library_id: detabaseObj.library_id,
    //                            catalog_id: detabaseObj.catalog_id,
    //                            title: this.folderName,
    //                            children:this.account,
    //                            isEdit: isEdit
    //                        }
    //                    }
    //
    //
    //                    await http.post('/wapi/v1/addEditFolder', data).then(res => {
    //
    //                        let success = res.success
    //
    //                        if (success) {
    //                            this.getForderList()
    //                            this.dialogVisible = false
    //                        }
    //
    //                        this.loading = false
    //
    //
    //                    })
    //                } catch (err) {
    //                    this.loading = false
    //                    //this.error()
    //                }
    //            },
    async search(queryString, cb) {
      this.queryString = queryString.trim()
      if (queryString) {
        try {
          let data = {
            tenant_id: this.$store.getters.getUser.tenant_id,
            user_id: this.$store.getters.getUser.user_id,
            search: queryString,
          }

          await http.post('/wapi/v1/getForderList', data).then((res) => {
            cb(res.data.folderArry)
          })
        } catch (err) {
          console.log(`error:${err}`)
        }
      } else {
        cb([])
      }
    },
    createStateFilter(queryString) {
      return (state) => {
        return state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
      }
    },
    //过滤
    handleSelect(item) {
      this.companyName = item.name

      this.$store.commit('setDatabase', {
        tenant_id: item.tenant_id,
        library_id: item.library_id,
        //                    catalog_id: item.catalog_id,
        title: item.name,
      })
      this.currentNodeKey = item.catalog_id
      this.myobj.id = item.catalog_id
      this.myobj.name = item.title
      this.$refs['menusTree'].setCurrentKey(item.catalog_id)

      this.$router.push({
        path: '/library/index?catalog_id=' + item.catalog_id,
      })
    },

    // 节点被点击
    handleNodeClick(data, node) {
      this.mynewFles = true
      this.isActive = false
      this.isActive3 = false
      this.myobj = data
      this.myIndex = node.level
      this.companyName = data.name
      if (parseInt(node.level) > 1) {
        this.id = data.id
      } else {
        this.isActive3 = true
        this.id = ''
      }

      this.sub_title = data.sub_title

      this.status = data.status

      this.myfileList()
      this.$store.commit('setDatabase', {
        tenant_id: data.tenant_id,
        library_id: data.library_id,
        //                    catalog_id: data.id,
        title: data.title,
      })
      this.$router.push({
        path: '/library/index?catalog_id=' + data.id + '&index=' + this.myIndex + '&id=' + new Date().getTime(),
      })

      //                this.$router.push({
      //                    path: '/database/index'
      //                })
    },

    //            myMouseover(){
    //
    //                window.clearInterval(window.setTim)
    //            },
    //            myMouseout(){
    ////                clearInterval(setTim)
    //                window.clearInterval(window.setTim)
    //                window.setTim=setTimeout(()=>{
    //                    this.isAmenu=false
    //                },2000)
    //            },
    //            //右击
    //            rightClick(e,data,node,ele){
    //                this.isActive=false
    //                var oEvent=e||event;
    //                this.isAmenu=true
    //                let x=oEvent.clientX
    //                let y=oEvent.clientY
    //                this.left=x+5+'px'
    //                this.top=y+5+'px'
    //                window.clearInterval(window.setTim)
    //                window.setTim=setTimeout(()=>{
    //                    this.isAmenu=false
    //                },2000)
    //                this.myobj=data
    //                this.$refs['menusTree'].setCurrentKey(data.id)
    //
    //
    //                this.myIndex=node.lavel
    //                this.companyName = data.name
    //                this.id=data.id
    //
    //                this.sub_title=data.sub_title
    //
    //                this.status=data.status
    //
    //
    //                this.myfileList()
    //                this.$store.commit('setDatabase', {
    //                    tenant_id: data.tenant_id,
    //                    library_id: data.library_id,
    //                    catalog_id: data.id,
    //                    title: data.title,
    //
    //                })
    //                this.$router.push({path:'/database/index?id='+new Date().getTime()})
    //
    //
    //            },
    //            fraternalClick(e){
    //               this.isAm1=true
    //               this.isAm2=false
    //                this.dialogVisible=true
    //                this.isAmenu=false
    //                this.id=this.myobj.parent_catalog
    //            },
    //            childrenClick(e){
    //                this.isAm1=false
    //                this.isAm2=true
    //                this.dialogVisible=true
    //                this.isAmenu=false
    //                this.id=this.myobj.id
    //
    //            },

    async refreshStore(rowObj) {
      if (rowObj.isEdit) {
        // for (const ind of this.treeNodes) {
        //     if (ind._id === rowObj.branchId) {//分公司
        //         for (const item of ind.children) {
        //             if (item._id === rowObj.dealerId) {//经销商
        //                 for (const itemObj of item.children) {
        //                     if (itemObj._id === rowObj.id) {
        //
        //                         itemObj.address = rowObj.address
        //                         itemObj.status = rowObj.status
        //
        //                         if (itemObj.status === "INACTIVE") {
        //                             itemObj.name = '(撤) ' + rowObj.name
        //                         } else {
        //                             itemObj.name = rowObj.name
        //                         }
        //
        //
        //                         break
        //                     }
        //                 }
        //
        //             }
        //         }
        //         let obj = this.$store.getters.getMyStore
        //
        //         if (obj.index) {
        //             obj.index = false
        //             this.$router.push({
        //                 path: '/store/index1'
        //             })
        //         }
        //         else {
        //             obj.index = true
        //             this.$router.push({
        //                 path: '/store/index'
        //             })
        //         }
        //     }
        // }
      } else {
        //新增  刷新
        // for (const ind of this.treeNodes) {
        //     if (ind._id === rowObj.branchId) {//分公司
        //         if (!ind.children) {
        //             continue
        //         }
        //         for (const item of ind.children) {
        //             if (item._id === rowObj.dealerId) {//经销商
        //                 if (!item.children) {
        //                     item.children = []
        //                 }
        //                 item.children.push({
        //                     _id: rowObj.id,
        //                     name: rowObj.name,
        //                     address: rowObj.address,
        //                     status: rowObj.status
        //                 })
        //
        //                 let obj = this.$store.getters.getMyStore
        //
        //                 if (obj.index) {
        //                     obj.index = false
        //                     this.$router.push({
        //                         path: '/store/index1'
        //                     })
        //                 }
        //                 else {
        //                     obj.index = true
        //                     this.$router.push({
        //                         path: '/store/index'
        //                     })
        //                 }
        //                 break
        //             }
        //         }
        //
        //     }
        // }
      }
    },
    inputMyAppend(data) {
      this.$refs['appendForm'].validate((valid) => {
        if (valid) {
          this.myAppend(data)
        } else {
          return false
        }
      })
    },
    closeAppend() {
      this.dialogVisible = false
      this.$refs['appendForm'].resetFields()
    },
    async myAppend(data) {
      // try {
      //     let data = {
      //         tenant_id: this.$store.getters.getUser.tenant_id,
      //         library_id: this.library_id,
      //         parent_catalog: this.id,
      //         title: this.appendForm.folderName,
      //         sub_title: this.appendForm.account,
      //         user_id: this.$store.getters.getUser.user_id
      //     }
      //     debugger
      //     await http2.post("api/dataBank/add", data).then(res => {
      //         debugger
      //         console.log(res)
      //     })
      // } catch (err) {
      //     console.log(`error:${err}`)
      // }

      let params = {
        tenant_id: this.$store.getters.getUser.tenant_id,
        library_id: this.library_id,
        parent_catalog: this.id,
        title: this.appendForm.folderName,
        sub_title: this.appendForm.account,
        user_id: this.$store.getters.getUser.user_id,
      }
      await http
        .post('/wapi/dataBank/add', params)
        .then((res) => {
          console.log(res)
        })
        .catch((err) => {})
      this.account = ''
      this.folderName = ''
      this.arraylist()
      this.dialogVisible = false
    },

    // 获取点击的经销商信息
    getDistributorInfo(data, total) {
      this.distributorInfo = data
      this.total = total
    },
    // 获取点击的门店信息
    getStoreInfo(data) {
      this.storeInfo = data
    },
    getBrachInfo(data) {
      this.brachInfo = data
    },
  },
}
</script>
<style lang="scss" module>
.container {
  padding-top: 20px;
  padding-right: 20px;
  padding-left: 20px;
  padding-bottom: 20px;
  background: #fff;
  height: auto;

  .left {
    font-size: 18px;
    font-weight: bold;
    color: #000000;

    .search {
      margin-top: 20px;
      width: 360px;
    }

    .type {
      em {
        color: #d98f2f;
        font-size: 14px;
        font-weight: bold;
      }
    }

    .first {
      color: #555555;
      font-size: 20px;
    }

    .font {
      margin-left: 20px;
      font-size: 14px;
      color: #555555;
    }
  }

  .right {
    margin-top: -20px;
    width: 100%;

    .header {
      width: 100%;
      padding-bottom: 20px;
      border-bottom: 2px dotted #e7eaec;
    }

    .body {
      margin-top: 10px;
    }
  }

  .noData {
  }
}
</style>
<style scoped>
.subjectList >>> .el-form-item__label {
  font-size: 14px;
  color: #000000;
  text-align: left;
}

.el-button--success {
  background-color: #4ec880;
  border-color: #4ec880;
}

.el-button--primary {
  background-color: #4a90e2;
  border-color: #4a90e2;
}

.el-button--danger {
  background-color: #ed3b3f;
  border-color: #ed3b3f;
}

.el-button--warning {
  background-color: #ff9901;
  border-color: #ff9901;
}
</style>
<style>
#myregion .el-tree-node:focus > .el-tree-node__content {
  background-color: #d8f6ee !important;
}

/*#myregion{*/
/*padding: 0;*/
/*}*/
#myregion .el-tree-node__content {
  height: 40px;
}
#myregion .el-input {
  padding: 5px 5px;
  border-bottom: 1px solid rgb(222, 222, 222);
}
#myInput {
  background: #ededed !important;
  height: 30px;
  width: 100%;
  text-align: center;
  border: rgb(237, 237, 237);
}
#myInput .el-input__inner::-webkit-input-placeholder {
  text-align: center;
}
#myregion .mySelect > div:first-child {
  background: #d8f6ee;
}

.src-pages-database-home---search---2ehTx_0 > div {
  display: flex;
  justify-content: center;
  padding: 0 10px;
}

#remenu {
  z-index: 9999;
  position: absolute;

  background: #fff;
  border: 1px solid #cccccc;
  border-radius: 3px;
  font-size: 12px;
  height: 40px;
  display: flex;
  width: 90px;
  align-content: stretch;
  justify-content: center;
  flex-wrap: wrap;
  padding: 0;
  margin: 0;
  overflow: hidden;
}

#remenu li {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #585757;
  line-height: 15px;
  width: 100%;
  cursor: pointer;
  transition: 0.2s;
}

#remenu li:hover {
  background: #7ab7fd;
  color: #fff;
}
#library .library_star label:after {
  content: '*';
  color: #f56c6c;
  margin-left: 4px;
}

/*.selectMenuE{*/
/*background: #7AB7FD;*/
/*color: #fff !important;*/
/*}*/

/*#myregion*/
</style>



// WEBPACK FOOTER //
// src/pages/database/home.vue